export const getPage = pages => {
  const url = window.location.href;
  const page = pages.find(x => url.includes(x.url));
  return page;
};
